var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal_wrapper"},[_c('div',{staticClass:"modal",style:({height:_vm.height})},[_c('div',{staticClass:"close_button"},[_c('i',{staticClass:"close large icon",staticStyle:{"margin":"0px"},on:{"click":_vm.closeMe}})]),_vm._v(" "),_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-29539ebc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TheSimpleModal.vue
// module id = null
// module chunks = 